import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable()
export class GraduateRegisterService {

  constructor(private _http: HttpClient) {
  }

  findGraduateDiplomaList(params, captchaData) {
    return this._http.post<any>('api/a/graduate/register/search', params, {
      params: {
        captchaId: captchaData.captchaId,
        captchaCode: captchaData.captchaCode
      }
    });
  }

  getAllGraduateCount() {
    return this._http.get<number>('api/a/graduate/register/count');
  }

  createRequestApplication(type, fd: FormData) {
    return this._http.post<any>(`api/a/register/graduate/create/request/${type}`, fd, {headers: {'noContentType': 'true'}});
  }

  /* with token*/
  getGraduateRequestList(params) {
    return this._http.post<any>('api/a/register/graduate/all/list', params);
  }

  getGraduateRequestById(id) {
    return this._http.get<any>(`api/a/register/graduate/get/${id}`);
  }

  getPlatonusDictionaryByUniversityId(universityId) {
    return this._http.get<any>(`api/a/register/graduate/university/dics/${universityId}`);
  }

  saveGraduateRequest(dto) {
    return this._http.post<any>('api/a/register/graduate/request/save', dto);
  }


  rejectGraduateRequest(dto) {
    return this._http.post<any>(`api/a/register/graduate/request/reject`, dto);
  }

  confirmGraduateRequest(dto) {
    return this._http.post<any>(`api/a/register/graduate/request/confirm`, dto);
  }

  generateExcel(page: any) {
    return this._http.post('api/a/register/graduate/generate/xls', page, {responseType: 'blob', observe: 'response'});
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/services/graduate-register.service.ts